import { Field, TextAreaEditor, TextEditor } from '@approvalmax/ui';
import { Flex, Grid } from '@approvalmax/ui/src/components';
import { constants } from 'modules/common';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import { messages } from './QBooksCounterpartyAddress.messages';
import { QBooksCounterpartyAddressProps } from './QBooksCounterpartyAddress.types';

const { qBooksConstants } = constants;

const qa = bemFactory.qa('reqf-qbooks-vendor-creation-popup');

export const QBooksCounterpartyAddress: FC<QBooksCounterpartyAddressProps> = memo((props) => {
    const { address, changeAddressProperty } = props;

    return (
        <Grid gridTemplateColumns='1fr 1fr' gap={16}>
            <Field title={messages.street}>
                <TextAreaEditor
                    qa={qa(`address-address-editor`)}
                    value={address.street ?? ''}
                    maxLength={qBooksConstants.ADDRESS_STREET_MAX_LENGTH}
                    onChange={changeAddressProperty('street')}
                    placeholder={messages.streetAddressPlaceholder}
                    minHeight={4}
                    maxHeight={8}
                />
            </Field>

            <Flex direction='column'>
                <Flex container>
                    <Flex size={12}>
                        <Field title={messages.cityTown}>
                            <TextEditor
                                qa={qa('city-town')}
                                value={address.city ?? ''}
                                maxLength={qBooksConstants.ADDRESS_CITY_MAX_LENGTH}
                                onChange={changeAddressProperty('city')}
                                placeholder={messages.cityTownPlaceholder}
                            />
                        </Field>
                    </Flex>

                    <Flex size={12}>
                        <Field title={messages.county_state_province}>
                            <TextEditor
                                qa={qa('county-state-province')}
                                value={address.state ?? ''}
                                maxLength={qBooksConstants.ADDRESS_REGION_MAX_LENGTH}
                                onChange={changeAddressProperty('state')}
                                placeholder={messages.countyStateProvincePlaceholder}
                            />
                        </Field>
                    </Flex>
                </Flex>

                <Flex container>
                    <Flex size={12}>
                        <Field title={messages.postalCode}>
                            <TextEditor
                                qa={qa('postal-code')}
                                value={address.postalCode ?? ''}
                                maxLength={qBooksConstants.ADDRESS_POSTCODE_MAX_LENGTH}
                                onChange={changeAddressProperty('postalCode')}
                                placeholder={messages.postalCodePlaceholder}
                            />
                        </Field>
                    </Flex>

                    <Flex size={12}>
                        <Field title={messages.country}>
                            <TextEditor
                                qa={qa('country')}
                                value={address.country ?? ''}
                                maxLength={qBooksConstants.ADDRESS_COUNTRY_MAX_LENGTH}
                                onChange={changeAddressProperty('country')}
                                placeholder={messages.countyPlaceholder}
                            />
                        </Field>
                    </Flex>
                </Flex>
            </Flex>
        </Grid>
    );
});

QBooksCounterpartyAddress.displayName = 'QBooksCounterpartyAddress';
